export default {
  namespaced: true,
  state: () => (
    {
      host: '',
      plat: ''
    }
  ),
  mutations: {
  },
  actions: {
    requestToLogin: ($store, userForm) => {
      return new Promise((resolve, reject) => {
        resolve()
      })
    },
    requestGongGaoProperty: ($store, obj) => {

    },
    requestGGFWConfig: ($store, obj) => {
      
    }
  }
}